import { TimeStringHelper } from "@goodgamestudios/core";
import { Poker2Constants } from "../../../constants/Poker2Constants";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2RegisterBonusDialogProperties } from "./Poker2RegisterBonusDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2RegisterBonusDialog extends Poker2Dialog {
    public static NAME: string = "Poker2RegisterBonusDialog";

    constructor(disp: Container) {
        super(disp);
    }

    protected init(): void {
        super.init();
        this.bonusDialog.tooltip._1.allowFastGlow = false;
        this.bonusDialog.tooltip._1.doCache();
    }

    protected applyProperties(): void {
        // bonusDialog.mc_xp_bonus.txt_offer_xp.text = bonusProperties.xpbonus;
        this.bonusDialog.btn_addmoney.label = Poker2Model.languageData.getTextById("generic_btn_okay");
        this.bonusDialog.txt_title.text = Poker2Model.languageData.getTextById("dialog_newUser_xpBonus_title");
        if (this.bonusProperties.event == 0) {
            this.bonusDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_newUser_xpBonus_copy");
        }
        else if (this.bonusProperties.event == 1) {
            this.bonusDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_newUser_xpBonus_copy2");
        }
        this.bonusDialog.tooltip.txt_time1.text = Poker2Model.languageData.getTextById("generic_payment_discount_time", [""]);
        var timeStr: string = TimeStringHelper.getTimeToString(this.bonusProperties.timeleft, TimeStringHelper.TWO_TIME_FORMAT, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData), false, true);
        this.bonusDialog.tooltip.txt_time2.text = timeStr;
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.bonusDialog.btn_close:
            case this.bonusDialog.btn_addmoney:
                this.hide();
                break;
        }
    }

    private get bonusProperties(): Poker2RegisterBonusDialogProperties {
        return this.properties as Poker2RegisterBonusDialogProperties;
    }

    private get bonusDialog(): Library.PokerPopUps.RegisterBonusXP {
        return this.disp as Library.PokerPopUps.RegisterBonusXP;
    }

}
